<template>
  <div class="tree-node" :style="{ marginLeft: depth * 20 + 'px' }">
    <div @click="toggle" class="tree-node-label">
      <span v-if="node.children && node.children.length" class="toggle-icon">
        <span class="ml-2">
          {{ node.type || node.language || node.id || node.codeValue }}
        </span>

        <span class="action-buttons ml-5" v-if="node.codeValue && mode != 'view'">
          <feather-icon
            icon="PlusIcon"
            title="Add Language"
            svgClasses="w-5 h-5 stroke-current cursor"
            class="add_icon ml-5"
            @click.stop="addButton(node)"
          />
        </span>
        <span class="action-buttons ml-5" v-if="node.language">
          <feather-icon
            icon="EyeIcon"
            title="View Content"
            svgClasses="w-5 h-5 stroke-current cursor"
            class="add_icon ml-5"
            @click.stop="viewData(node)"
          />
          <feather-icon
            icon="EditIcon"
            v-if="mode != 'view'"
            title="Edit Content"
            svgClasses="w-5 h-5 stroke-current cursor"
            class="edit_icon"
            @click.stop="editData(node)"
          />
          <feather-icon
            icon="Trash2Icon"
            title="Delete Content"
            v-if="mode != 'view'"
            svgClasses="w-5 h-5 stroke-current cursor"
            class="delete_icon"
            @click.stop="deleteData(node)"
          />
        </span>
      </span>
    </div>
    <div v-if="isOpen">
      <!-- Render children recursively -->
      <div v-if="node.children && node.children.length">
        <TreeNode
          v-for="(child, index) in node.children"
          :key="child.id || index"
          :node="child"
          :mode="mode"
          :depth="depth + 1"
          @viewContent="$emit('viewContent', $event)"
          @editContent="$emit('editContent', $event)"
          @deleteContent="$emit('deleteContent', $event)"
          @addLanguage="$emit('addLanguage', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TreeNode",
  props: {
    mode: String,
    node: {
      type: Object,
      required: true,
    },
    depth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    viewData(node) {
      this.$emit("viewContent", node);
    },
    editData(node) {
      this.$emit("editContent", node);
    },
    deleteData(node) {
      this.$emit("deleteContent", node);
    },
    addButton(node) {
      this.$emit("addLanguage", node);
    },
  },
};
</script>

<style scoped>
.tree-node {
  margin-bottom: 5px;
  transition: all 0.5s;
}
.tree-node-label {
  cursor: pointer;
  font-weight: bold;
  margin-top: 5px;
}
.toggle-icon {
  border-radius: 0.5rem;
  font: inherit;
  border: 0;
  padding: 8px 8px;
  padding-right: 0;
  width: 50%;
  text-align: left;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #2e68b266;
  border: solid rgba(0, 0, 0, 0.2);
  background: #2e68b266;
}
.action-buttons {
  right: 20px;
  top: 10px;
  position: absolute;
}
.menu-sub-list {
  display: none;
  padding: 5px;
  background-color: #fbfbfb;
  border-radius: 5px;
  box-shadow: 0 10px 20px rgba(#404040, 0.15);
  position: absolute;
  left: 100%;
  right: 0;
  z-index: 1000;
  width: 15.5rem;
  top: 0;
  flex-direction: column;
  &:hover {
    display: flex;
  }
}

.menu-item {
  position: relative;
}

.menu-button {
  font: inherit;
  border: 0;
  padding: 8px 8px;
  padding-right: 0;
  width: 50%;
  text-align: left;
  display: flex;
  align-items: center;
  position: relative;
  background-color: var(--color-bg-secondary);
  border: solid rgba(0, 0, 0, 0.2);
}
.add_icon {
  color: rgba(var(--vs-success), 1);
  margin-right: 12px;
}
.edit_icon {
  color: rgba(var(--vs-warning), 1);
  margin-right: 12px;
}
.delete_icon {
  color: rgba(var(--vs-danger), 1);
  margin-right: 12px;
}
/* .tree-node:hover {
  transform: translateX(0.5rem);
} */
</style>
